var SwipeObj = function (hasScrollBar) {
	this.el = null;
	this._enabled = null;
	this._start = 0;
	this.diff = null;
	this.coordinates = 0;
	this.hasScrollBar = hasScrollBar;

	this.init = function (el, data) {
		var _this = this;

		this.el = el;

		this.setDiff();
		$(window).on('resize', function () {
			_this.setDiff();
		});

		this._move(data);

	}

	this.setDiff = function () {
		this.diff = this.el.width() - this.el.parent().width();
		if (this.diff > 0)
			this._position();
	}

	this._move = function (actions) {
		var _this = this,
			percentX = 0,
			coordX, coordsDiffX,
			_eDown, _eUp, _eMove;

		if ('ontouchstart' in document.documentElement) {
			_eDown = 'touchstart';
			_eUp = 'touchend';
			_eMove = 'touchmove';
		} else {
			_eDown = 'mousedown';
			_eUp = 'mouseup';
			_eMove = 'mousemove';
		}

		if (actions == false) {
			_this.el.unbind(_eDown, _eUp, _eMove);
		} else {
			_this.el.bind(_eDown, function (e) {
				var e = e || window.event;

				if (e.type == 'touchstart') {
					e = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0];
				} else {
					if (e.which !== 1) return;
				}

				_this._start = e.pageX;

				$(this).bind(_eMove, function (ev) {
					ev = ev || window.event;

					if (ev.type == 'touchmove') {
						ev = ev.originalEvent.touches[0] || ev.originalEvent.changedTouches[0];
					}

					$(this).addClass('swipe');

					coordX = ev.pageX;

					coordsDiffX = coordX - _this._start;

					if ((_this.diff / 100) > 0) {
						percentX = coordsDiffX / (_this.diff / 100);
					}

					_this.coordinates -= percentX;

					if (_this.coordinates < 0) _this.coordinates = 0;
					if (_this.coordinates > 100) _this.coordinates = 100;

					_this._start = coordX;

					_this._position();
				});


			});


			$('body').on(_eUp, function (e) {
				_this.el.removeClass('swipe');
				_this.el.unbind(_eMove);
			});
		}
	}

	this._position = function () {
		if (!this.el || this._enabled == false) return;

		this.el.css('left', -(this.diff / 100 * this.coordinates) + 'px');

		if (this.coordinates == 100)
			this.el.parent().addClass('swipe-end');
		else
			this.el.parent().removeClass('swipe-end');

		if (this.hasScrollBar == true) {
			var scrollbar = this.el.parent().parent().find('.swiper-scrollbar')[0];

			scrollbar.style.setProperty('--thumbLeft', (this.diff / 100 * this.coordinates) + 'px');
			scrollbar.style.setProperty('--thumbWidth', this.diff + 'px');
		}
	}
}

export var swiper = function (el, options, hasScrollBar) {
	this.el = el;
	this.wrap = null;
	this.breakpoint = null;
	this._active = null;
	this._swiper = null;
	this.hasScrollBar = hasScrollBar;

	this.init = function () {
		var _this = this;

		if (this.el.hasClass('swiper-block'))
			return;

		this._swiper = new SwipeObj(this.hasScrollBar);

		if (options !== undefined) {
			this.breakpoint = options.breakpoint;
		}

		this.prepare();

		this._isActive();
		$(window).on('resize', function () {
			_this._isActive();
		});

	}

	this.prepare = function () {
		this.el.addClass('swiper-block').wrap('<div class="swiper-wrap" />');
		this.wrap = this.el.closest('.swiper-wrap');
	}

	this._isActive = function () {
		var _this = this,
			points = [];

		switch (this.breakpoint) {
			case null:
				points = [_this.wrap.outerWidth(), _this.el.outerWidth(true)];
				break;
			default:
				points = [window.innerWidth, _this.breakpoint];
				break;
		}

		if (points[0] <= points[1]) {
			if (this._active == null || this._active == false) {
				this.enable();
				this._active = true;
			}
		} else {
			if (this._active == null || this._active == true) {
				this.destroy();
				this._active = false;
			}
		}
	}

	this.destroy = function () {
		this.wrap.removeClass('swiper-init').css('height', '');
		this._swipe(false);
	}

	this.enable = function () {
		this.wrap.addClass('swiper-init').css('height', this.el.outerHeight(true) + 'px');
		this._swipe();
	}

	this._swipe = function (act) {
		var sw = this._swiper,
			el = this.el;

		if (act == false) {
			sw.init(el, false);
			sw.coordinates = 0;
			sw._enabled = false;

			el.css('left', '');
		} else {
			sw.init(el);
			sw._enabled = true;
		}
	}

	return this.init();
}


// WEBPACK FOOTER //
// app/scripts/components/swiper.js